<template>
  <div class="blue darken-4">
    <v-row no-gutters class="mx-2" justify="center">
      <v-col cols="2">
        <v-text-field data-test="search"
                      hide-details single-line dark clearable
                      prepend-icon="mdi-magnify"
                      :value="filterProject.filter"
                      @input="emitFilter({filter: $event})"/>
      </v-col>

      <v-col cols="2" offset="1">
        <v-select data-test="sort"
                  dark single-line
                  item-text="label"
                  :label="$t('project.sort_label')"
                  :items="sortOptions"
                  :value="filterProject.sorter"
                  @input="emitFilter({sorter: $event})"/>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import EnumMixin from '@/components/Mixins/EnumMixin.vue';
import { SelectOption } from '@/classes/SelectOption';
import type { Filter } from '@/interfaces/PayloadsType';

enum sortOptions {
  'by_name_asc' = 'by_name_asc',
  'by_name_desc' = 'by_name_desc',
  'by_date_desc' = 'by_date_desc'
}

const defaultFilter = (): Filter => ({
  filter: '',
  sorter: ''
});

@Component
export default class ProjectSearch extends Mixins(EnumMixin) {

  @Prop({ default: defaultFilter })
  readonly filterProject!: Filter;

  emitFilter({ filter = this.filterProject.filter, sorter = this.filterProject.sorter }: Partial<Filter>): void {
    this.$emit('updateProjectFilter', {
      filter: filter ?? '',
      sorter
    });
  }

  get sortOptions(): SelectOption[] {
    return this.getEnumOptions(sortOptions, 'project.sort_options');
  }
}
</script>

<!-- TODO Should be scoped -->
<!-- TODO Should use sass instead -->
<style lang="stylus">
@import '../../stylus/main.styl';

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.panel {
  .project-details {
    vertical-align: middle;

    .project-name {
      color: $grey-color;
    }

    .project-country {
      color: $grey-color;
      opacity: 0.7;
    }

    .scenario-count {
      color: $grey-color;
      opacity: 0.7;
    }

    .d-flex {
      height: 55px;
    }
  }
}

.panel:hover {
  .project-header {
    background-color: #EEEEEE88;
  }
}

.configuration-div {
  flex-grow: 1;

  img {
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}

.scenario {
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .scenario-date {
    font-size: 12px;
    color: $grey-color;
    opacity: 0.7;
  }

  .scenario-title {
    color: $blue-title;
    font-weight: bold;
    line-height: 2em;
    max-height: 4em;
  }
}

.hoverable {
  transform: translateY(0px);
  transition: 0.5s;
}

.hoverable:hover {
  box-shadow: 0 0 20px -3px #555555;
  transform: translateY(-5px);
  transition: 0.5s ease-out;
}

.add-scenario {
  position: relative;
  cursor: pointer;

  .item-emph {
    position: absolute;
    height: 100%;
    width: 100%;
    text-align: center;
    vertical-align: middle;

    span {
      position: absolute;
      text-align: center;
      display: inline-block;
      background-color: white;
      border-radius: 50%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .v-icon {
        font-size: 50px;
      }
    }
  }
}

.card-text {
  flex-grow: 1;

  .subtext {
    text-align: center;
    justify-content: space-around;
    font-size: 1em;
    line-height: 1rem;
    max-height: 2rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

.scenario-energy-efficiency {
  position: absolute;
  background-color: #007B47;
  height: 125px;
  right: -50px;
  top: -60px;
  width: 100px;
  -webkit-transform: rotate(-45deg);

  .scen-energy-icon {
    position: absolute;
    -webkit-transform: rotate(45deg) translate(50px, 25px);
    color: white;
    right: 90px;
  }
}

.hov-btn {
  margin: 0 7px;

  .v-btn__content .v-icon {
    color: $deep-blue;
  }

  .v-btn__content .v-icon:hover {
    color: white;
  }
}

.efficiency-mark {
  margin: 0 7px;
}

.hov-btn:hover {
  background: $deep-blue;
}

.first-project-video {
  background: white;
  border-radius: 3px;
  display: inline-block;

  .first-video-button {
    display: inline-block;
  }

  .wellcome-text {
    display: inline-block;
    font-size: 14px;
    vertical-align: middle;
    color: $deep-blue;
    height: 100%;
  }
}

</style>
